export const MATCH_SPACES = /\S+/g;

export const CEL_NUMBER = /\(\d{2,}\) \d{4,}-\d{4}/g;

export const ONLY_NUMBER = /\d+/g;

